import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAmplitude } from '@/amplitude/amplitudeContext';

export const useAmplitudePageTracking = () => {
	const router = useRouter();
	const { amplitudeInstance } = useAmplitude();

	useEffect(() => {
		const handleRouteChange = (url: string) => {
			if (amplitudeInstance) {
				amplitudeInstance.logEvent('Page Viewed', { page: url });
			}
		};

		if (amplitudeInstance) {
			amplitudeInstance.logEvent('Page Viewed', { page: router.pathname });
		}

		router.events.on('routeChangeComplete', handleRouteChange);

		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};
	}, [router.events, amplitudeInstance]);
};
